import { ApolloLink } from './ApolloLink';

export const concat = ApolloLink.concat;



// WEBPACK FOOTER //
// ../../../src/link/core/concat.ts